import { gql } from '@apollo/client';
import tasksDueNotificationBaseFragment from './fragments/tasksDueNotificationBaseFragment';
import observationReportNotificationFragment from './fragments/observationReportNotificationFragment';

const GET_TASKS_DUE_NOTIFICATIONS_QUERY = gql`
  query GetTasksDueNotifications {
    tasksDueNotifications {
      ...TasksDueNotificationBaseFields
      ...ObservationReportNotificationFields
    }
  }

  ${tasksDueNotificationBaseFragment}
  ${observationReportNotificationFragment}
`;

export default GET_TASKS_DUE_NOTIFICATIONS_QUERY;
